<template>
    <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
        <div class="header-bg">
            <div class="content-nav-bar">
                <van-nav-bar title="设置多因子条件">
                    <template #left>
                        <van-icon name="arrow-left" size="18" @click="goBack" />
                    </template>
                </van-nav-bar>
            </div>
            <div class="content" :style="`height:calc(100vh - ${contentNavBar}px)`">
                <div class="yz-list">
                    <FactorArgumentsModal></FactorArgumentsModal>

                    <!-- <van-empty
            description="请添加因子"
            :image="require('@/assets/image/notData.png')"
            v-else
          /> -->
                </div>

                <div class="condition">
                    <h2 class="h2">持股周期</h2>

                    <div class="period">
                        <van-row gutter="12">
                            <van-col span="6" v-for="(item, index) in periodArr" :key="index">
                                <div
                                    :class="{ active: item.checked }"
                                    @click="handleClickCol(index)"
                                >
                                    {{ item.name }}
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="period-value" v-if="isCustomSelected">
                        <van-field
                            v-model="value"
                            placeholder="输入天数，以逗号分隔，范围为2-99"
                            @blur="handleBlur"
                        />

                        <p v-if="isShowCgzqText" class="isShowCgzqText">
                            输入天数范围应该在2-99之间
                        </p>
                    </div>

                    <h2
                        class="h2"
                        style="margin-top: 16px"
                        v-if="!publicHcID || (Obj.startDate && Obj.endDate)"
                    >
                        选定回测周期
                        <span
                            style="font-size: 12px; color: #999999"
                            v-if="$route.query.yzType != 'ETF'"
                            >(建议不超过5年)</span
                        >
                    </h2>

                    <div class="date-time" v-if="!publicHcID || (Obj.startDate && Obj.endDate)">
                        <p @click="beginshow = true">{{ newBeginCurrentDate }}</p>
                        <p>至</p>
                        <p @click="endshow = true">{{ newEndCurrentDate }}</p>
                    </div>

                    <van-action-sheet v-model="beginshow">
                        <div class="action-sheet-content">
                            <van-datetime-picker
                                v-model="beginCurrentDate"
                                type="date"
                                title="选择开始日期"
                                :min-date="beginMinDate"
                                :max-date="beginMaxDate"
                                @confirm="beginHandleConfirm"
                                @cancel="beginHandleCancel"
                            />
                        </div>
                    </van-action-sheet>

                    <van-action-sheet v-model="endshow">
                        <div class="action-sheet-content">
                            <van-datetime-picker
                                v-model="endCurrentDate"
                                type="date"
                                title="选择结束日期"
                                :min-date="endMinDate"
                                :max-date="endMaxDate"
                                @confirm="endHandleConfirm"
                                @cancel="endHandleCancel"
                            />
                        </div>
                    </van-action-sheet>
                </div>
            </div>

            <div class="bottom-pd">
                <div class="bottom-btn" v-if="!loading">
                    <div
                        class="left"
                        @click="checkedYzNum.length > 0 ? (showActionSheet = true) : ''"
                    >
                        已选中的因子 <span class="num">{{ checkedYzNum }}</span>
                    </div>
                    <van-button type="primary" class="r-btn" @click="openHcFun">{{
                        publicHcID ? '再次回测' : '立即回测'
                    }}</van-button>
                </div>

                <van-button loading-text="回测中..." :loading="loading" v-else class="setup-ing"
                    >回测中...</van-button
                >
            </div>
        </div>

        <takeOut
            :show="takeShow"
            :name="takeName"
            :btnText="takeBtnName"
            type="hc"
            @cancelBasis="cancelBasis"
            @linkGo="linkGo"
        ></takeOut>
    </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import {
    judgeColor,
    toFixedNum,
    removeValueFromArray,
    dateFormat,
    getPreviousDay,
    getPreviousYear,
    strToHexCharCode,
    factorCombinationToCode
} from '@/utils/format';
import { initiateDyzHc } from '@/api/create.js';
import { getClientRedis } from '@/api/index.js';

export default {
    name: 'DyzArguments',
    mixins: [mixin],
    data() {
        return {
            currentCustom: -1,
            periodArr: [
                {
                    name: '1天',
                    checked: false
                },
                {
                    name: '2天',
                    checked: false
                },
                {
                    name: '3天',
                    checked: false
                },
                {
                    name: '5天',
                    checked: false
                },
                {
                    name: '10天',
                    checked: false
                },
                {
                    name: '20天',
                    checked: false
                },
                {
                    name: '30天',
                    checked: false
                },
                {
                    name: '60天',
                    checked: false
                },
                {
                    name: '自定义',
                    checked: false
                }
            ],
            selectedPeriods: [], // 用于存储选中的 name 值的数组
            value: '',
            isCustomSelected: false, // 用于标记是否点击了自定义选项
            beginCurrentDate: '',
            endCurrentDate: '',
            newBeginCurrentDate: '',
            newEndCurrentDate: '',
            beginshow: false,
            endshow: false,
            beginMinDate: new Date(2015, 0, 1),
            beginMaxDate: new Date(),
            endMinDate: new Date(2015, 0, 1),
            endMaxDate: new Date(),
            loading: false,
            takeShow: false,
            takeName: '',
            takeBtnName: '',
            isShowKd: false,
            isShowCgzqText: false,
            // 选中的因子数量
            checkedYzNum: 0
        };
    },
    //计算属性
    computed: {
        checkedYzList: function () {
            return this.$store.state.checkedYzList; // 获取全局状态
        },
        Obj: function () {
            return this.$store.state.Obj; // 获取全局状态
        },
        contentNavBar: function () {
            return this.$store.state.contentNavBar; // 获取全局状态
        },
        publicHcID: function () {
            return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
        },
        type: function () {
            return this.$store.state.type; // 获取vuex的id 要是存在id走编辑逻辑
        },
        groupYzList() {
            return this.$store.state.groupYzList;
        },
        checkedYzType(){
            return this.$store.state.checkedYzType;
        }
    },

    watch: {},
    components: {},
    filters: {},
    created() {
        // this.getClientFun();
        if (this.$route.query.yzType == 'ETF') {
            this.beginMinDate = new Date(
                window.LHJY_CONDITION.etf_start_time[0],
                window.LHJY_CONDITION.etf_start_time[1],
                window.LHJY_CONDITION.etf_start_time[2]
            );
            this.endMinDate = new Date(
                window.LHJY_CONDITION.etf_start_time[0],
                window.LHJY_CONDITION.etf_start_time[1],
                window.LHJY_CONDITION.etf_start_time[2]
            );
        } else {
            this.beginMinDate = new Date(
                window.LHJY_CONDITION.start_time[0],
                window.LHJY_CONDITION.start_time[1],
                window.LHJY_CONDITION.start_time[2]
            );
            this.endMinDate = new Date(
                window.LHJY_CONDITION.start_time[0],
                window.LHJY_CONDITION.start_time[1],
                window.LHJY_CONDITION.start_time[2]
            );
        }
    },
    mounted() {
        // if (window.DzhAppJs) {
        //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
        // }

        this.$store.commit('setBtnDisabled', false);
        var receivedDays = [];
        if (this.Obj.isCustomSelected) {
            this.isCustomSelected = this.Obj.isCustomSelected;
            this.value = this.Obj.holdPeriodList;
            this.periodArr[8].checked = true;
            this.currentCustom = 8;
        } else {
            // 获取传入的天数数组（假设为 receivedDays）
            if (this.Obj.holdPeriodList) {
                receivedDays = this.Obj.holdPeriodList.split(',');
            } else {
                receivedDays = [1, 2, 3, 5]; // 示例数据
            }
            // 遍历天数数组，选中对应的选项
            for (var day of receivedDays) {
                var index = this.periodArr.findIndex((item) => item.name.includes(day));
                if (index !== -1) {
                    this.periodArr[index].checked = true;
                    this.selectedPeriods.push(this.periodArr[index].name);
                }
            }
        }

        if (this.Obj.startDate && this.Obj.endDate) {
            this.beginCurrentDate = new Date(dateFormat('YYYY-MM-DD', this.Obj.startDate));
            this.endCurrentDate = new Date(dateFormat('YYYY-MM-DD', this.Obj.endDate));
            this.newBeginCurrentDate = dateFormat('YYYY-MM-DD', this.Obj.startDate);
            this.newEndCurrentDate = dateFormat('YYYY-MM-DD', this.Obj.endDate);
        } else {
            this.beginCurrentDate = new Date(getPreviousYear());
            this.endCurrentDate = new Date(getPreviousDay());
            this.newBeginCurrentDate = getPreviousYear();
            this.newEndCurrentDate = getPreviousDay();
        }

        this.beginMaxDate = new Date(
            this.newEndCurrentDate.split('-')[0],
            this.newEndCurrentDate.split('-')[1] - 1,
            this.newEndCurrentDate.split('-')[2]
        );
        this.endMaxDate = new Date(
            this.newEndCurrentDate.split('-')[0],
            this.newEndCurrentDate.split('-')[1] - 1,
            this.newEndCurrentDate.split('-')[2]
        );
        this.checkedYzNumStatic();
    },
    methods: {
        judgeColor,
        toFixedNum,

        //查询是否显示扣豆
        getClientFun() {
            var _this = this;
            getClientRedis({})
                .then((res) => {
                    if (res.err === 200) {
                        var data = JSON.parse(res.data);
                        _this.setLocalData(data);
                        if (data.hc === 'true') {
                            _this.isShowKd = false;
                        } else {
                            _this.isShowKd = true;
                        }
                    } else {
                        _this.isShowKd = true;
                        _this.setLocalData();
                    }
                })
                .catch(() => {
                    _this.isShowKd = true;
                    _this.setLocalData();
                });
        },

        //删除选中的因子 -
        delYz: function (item) {
            removeValueFromArray(this.checkedYzList, item.ID);
            this.$store.commit('setCheckedYzList', this.checkedYzList);
        },

        //选择周期
        handleClickCol(index) {
            if (index === this.periodArr.length - 1) {
                // 点击了自定义选项
                this.currentCustom = index;
                this.isCustomSelected = true; // 标记点击了自定义选项
                // 取消其他选项的选中状态
                this.periodArr.forEach((item, idx) => {
                    item.checked = idx === index;
                });
                // 清空选中的值数组
                this.selectedPeriods = [];
            } else {
                this.value = '';
                // 点击了非自定义选项
                if (this.currentCustom !== -1) {
                    // 取消自定义选项的选中状态
                    this.periodArr[this.currentCustom].checked = false;
                    this.currentCustom = -1;
                    this.isCustomSelected = false; // 取消自定义选项的标记
                }
                // 切换选中状态
                this.periodArr[index].checked = !this.periodArr[index].checked;

                // 更新选中的值数组
                var selectedPeriod = this.periodArr[index].name;
                if (this.periodArr[index].checked && index !== this.periodArr.length - 1) {
                    this.selectedPeriods.push(selectedPeriod);
                } else {
                    var selectedIndex = this.selectedPeriods.indexOf(selectedPeriod);
                    if (selectedIndex !== -1) {
                        this.selectedPeriods.splice(selectedIndex, 1);
                    }
                }
            }
        },

        //自定义周期失去焦点
        handleBlur: function () {
            // 删除非数字字符，保留逗号
            const cleanedValue = this.value.replace(/[^0-9,]/g, '');

            // 保留相邻的逗号中的一个
            const uniqueCommas = cleanedValue.replace(/,{2,}/g, ',');

            // 拆分字符串为数字数组
            const numbers = uniqueCommas.split(',').map(Number);

            // 过滤掉小于等于零的数字并限制最大值为60
            const filteredNumbers = numbers.filter((num) => num > 1 && num <= 99);

            // 截取前10条数字
            const slicedNumbers = filteredNumbers.slice(0, 10);

            // 排序数字数组
            const sortedNumbers = slicedNumbers.sort((a, b) => a - b);

            // 删除重复的数字
            const uniqueNumbers = [...new Set(sortedNumbers)];

            // 更新输入框的值
            this.value = uniqueNumbers.join(',');
        },

        //格式化时间
        timeFormat: function (time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var day = date.getDate().toString().padStart(2, '0');
            return year + '-' + month + '-' + day;
        },

        beginHandleConfirm: function (i) {
            this.beginCurrentDate = this.timeFormat(i);
            this.newBeginCurrentDate = this.timeFormat(i);
            this.beginshow = false;

            let isValid = this.compareDates(this.newBeginCurrentDate, this.newEndCurrentDate);
            if (isValid) {
                this.$toast('结束日期不能小于或等于开始日期');
            }
        },
        beginHandleCancel: function () {
            this.beginshow = false;
        },
        endHandleConfirm: function (i) {
            this.endCurrentDate = this.timeFormat(i);
            this.newEndCurrentDate = this.timeFormat(i);

            this.endshow = false;

            let isValid = this.compareDates(this.newBeginCurrentDate, this.newEndCurrentDate);
            if (isValid) {
                this.$toast('结束日期不能小于或等于开始日期');
            }
        },
        endHandleCancel: function () {
            this.endshow = false;
        },

        //判断结束时间不能小于开始时间
        compareDates: function (startDate, endDate) {
            let start = new Date(startDate);
            let end = new Date(endDate);

            if (end > start) {
                return false; // endDate 大于 startDate
            } else {
                return true; // endDate 小于等于 startDate
            }
        },

        cancelBasis: function () {
            this.takeShow = false;
        },

        linkGo: function () {
            var _this = this;

            _this.takeShow = false;

            if (!_this.checkedYzList.length) {
                _this.$toast('至少添加一个因子');

                return false;
            }
            if (
                (!_this.selectedPeriods.length && !_this.isCustomSelected) ||
                (_this.isCustomSelected && _this.value === '')
            ) {
                _this.isShowCgzqText = true;
                // _this.$toast('请选择持股周期');

                return false;
            } else {
                _this.isShowCgzqText = false;
            }

            _this.loading = true;

            //把持股周期从大到小排序
            var cgzq = _this.selectedPeriods
                .map((item) => parseInt(item, 10)) // 将字符串转换为数字
                .sort((a, b) => a - b); // 按从小到大排序

            var idArray = _this.checkedYzList.map((obj) => {
                if (obj.yzType != 0) {
                    //自选和模版的取info字段 其他的直接取id
                    if (obj.yzType == 4) {
                        return '&F' + strToHexCharCode(obj.Info);
                    } else {
                        return '&' + obj.Info;
                    }
                } else {
                    return '&' + obj.ID;
                }
            });

            var hexyzIds = ':' + strToHexCharCode(':' + idArray.join('') + '&');

            var params = {
                factorList: hexyzIds, //string 因子列表
                holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                endDate: _this.newEndCurrentDate.replace(/-/g, '') //string 结束时间 : 20230101
            };

            initiateDyzHc(params)
                .then((res) => {
                    _this.loading = false;
                    _this.$toast(res.msg || '网络超时!请稍后重试');

                    //把持股周期从大到小排序
                    var cgzq = _this.selectedPeriods
                        .map((item) => parseInt(item, 10)) // 将字符串转换为数字
                        .sort((a, b) => a - b); // 按从小到大排序

                    var Obj = {};

                    //如果是策略详情编辑过来的  没有回测周期
                    /**
                     * ! 新增了 判断 publicHcID 使 isEdit 是否是编辑状态 (王文浩)
                     * */
                    if (_this.type === 'clDetails') {
                        Obj = {
                            factorList: idArray.toString(), //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            apiData: res.data,
                            name: _this.Obj.name, //策略名称
                            desc: _this.Obj.desc, //策略描述
                            isEdit: _this.publicHcID ? true : false //是否是编辑
                        };
                    } else {
                        Obj = {
                            factorList: idArray.toString(), //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                            endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            apiData: res.data,
                            name: _this.Obj.name, //策略名称
                            desc: _this.Obj.desc, //策略描述
                            isEdit: _this.publicHcID ? true : false //是否是编辑
                        };
                    }

                    _this.$store.commit('setObj', Obj);

                    if (res.err == 200) {
                        _this.$router.push({
                            path: '/Dyz-preview',
                            name: 'Dyz-preview',
                            query: {
                                token: _this.$route.query.token || '',
                                HashID: res.data.HashID,
                                source: _this.$route.query.source || '',
                                mySource: _this.$route.query.mySource || '',
                                themeStyleVs: _this.$route.query.themeStyleVs || 0,
                                version: _this.$route.query.version || '',
                                yzType: this.$route.query.yzType || 'A'
                            }
                        });
                    }
                })
                .catch((err) => {
                    _this.loading = false;
                    _this.$toast(err);
                });
        },

        openHcFun: function () {
            var _this = this;

            // if (_this.isShowKd) {
            //   _this.takeName = '每次使用回测功能需消耗 2个慧豆';
            //   _this.takeBtnName = '继续回测';
            //   _this.takeShow = true;
            //   return false;
            // }

            if (!_this.checkedYzList.length) {
                _this.$toast('至少添加一个因子');

                return false;
            }
            if (
                (!_this.selectedPeriods.length && !_this.isCustomSelected) ||
                (_this.isCustomSelected && _this.value === '')
            ) {
                _this.isShowCgzqText = true;
                // _this.$toast('请选择持股周期');

                return false;
            } else {
                _this.isShowCgzqText = false;
            }

            _this.loading = true;

            //把持股周期从大到小排序
            var cgzq = _this.selectedPeriods
                .map((item) => parseInt(item, 10)) // 将字符串转换为数字
                .sort((a, b) => a - b); // 按从小到大排序

            // 组合因子交并集
            var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);


            // 父级因子组合
            // var idArray = _this.checkedYzList.map((obj) => {
            //     // 0-普通因子 1-自选 2 普通自定义因子 3-调优模版  4-大智慧公式因子
            //     if (obj.yzType != 0) {
            //         //自选和模版的取info字段 其他的直接取id
            //         if (obj.yzType == 4) {
            //             return '&F' + strToHexCharCode(obj.Info);
            //         } else {
            //             return '&' + obj.Info;
            //         }
            //     } else {
            //         return '&' + obj.ID;
            //     }
            // });

            // console.log('idArray', idArray);

            // 子集因子组合

            // 拼接因子组合

            // debugger;

            // var hexyzIds = ':' + strToHexCharCode(':' + idArray.join('') + '&');
            var params = {
                factorList: hexYzObj.hexyzIds, //string 因子列表
                holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                endDate: _this.newEndCurrentDate.replace(/-/g, '') //string 结束时间 : 20230101
            };

            initiateDyzHc(params)
                .then((res) => {
                    _this.loading = false;
                    _this.$toast(res.msg || '网络超时!请稍后重试');

                    //把持股周期从大到小排序
                    var cgzq = _this.selectedPeriods
                        .map((item) => parseInt(item, 10)) // 将字符串转换为数字
                        .sort((a, b) => a - b); // 按从小到大排序

                    var Obj = {};

                    //如果是策略详情编辑过来的  没有回测周期
                    /**
                     * ! 新增了 判断 publicHcID 使 isEdit 是否是编辑状态 (王文浩)
                     * */
                    if (_this.type === 'clDetails') {
                        Obj = {
                            factorList: hexYzObj.idArrayToStr, //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            apiData: res.data,
                            name: _this.Obj.name, //策略名称
                            desc: _this.Obj.desc, //策略描述
                            isEdit: _this.publicHcID ? true : false //是否是编辑
                        };
                    } else {
                        Obj = {
                            factorList: hexYzObj.idArrayToStr, //string 因子列表
                            holdPeriodList: _this.isCustomSelected ? _this.value : cgzq.toString(), //string 持股周期: 1,2,3,4,5,6
                            startDate: _this.newBeginCurrentDate.replace(/-/g, ''), //string 开始时间 : 20220101
                            endDate: _this.newEndCurrentDate.replace(/-/g, ''), //string 结束时间 : 20230101
                            isCustomSelected: _this.isCustomSelected, //是否是自定义周期
                            apiData: res.data,
                            name: _this.Obj.name, //策略名称
                            desc: _this.Obj.desc, //策略描述
                            isEdit: _this.publicHcID ? true : false //是否是编辑
                        };
                    }

                    _this.$store.commit('setObj', Obj);

                    if (res.err == 200) {
                        _this.$router.push({
                            path: '/Dyz-preview',
                            name: 'Dyz-preview',
                            query: {
                                token: _this.$route.query.token || '',
                                HashID: res.data.HashID,
                                source: _this.$route.query.source || '',
                                mySource: _this.$route.query.mySource || '',
                                themeStyleVs: _this.$route.query.themeStyleVs || 0,
                                version: _this.$route.query.version || '',
                                yzType: _this.$route.query.yzType || 'A',
                                publicHcID: _this.$route.query.publicHcID || ''
                            }
                        });
                    }
                })
                .catch((err) => {
                    _this.loading = false;
                    _this.$toast(err);
                });
        },
        goBack: function () {
            this.$router.push({
                path: '/checkedYz',
                name: 'CheckedYz',
                query: {
                    source: this.$route.query.source, //用来标注是从多因子还是量化过去的
                    type: 'add',
                    token: this.$route.query.token || '',
                    mySource: this.$route.query.mySource,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || '',
                    yzType: this.$route.query.yzType || 'A',
                    dtzhHcCheckedYzList: this.$route.query.dtzhHcCheckedYzList || '',
                    dtzhCheckedYzList: this.$route.query.dtzhCheckedYzList || '',
                    publicHcID: this.publicHcID
                }
            });
        },
        // 计算选中的因子
        checkedYzNumStatic() {
            console.log('groupYzList', this.groupYzList);

            const allIDs = this.groupYzList.flat();
            this.checkedYzNum = this.checkedYzList.length + allIDs.length;
        }
    }
};
</script>
<style lang="less" scoped>
::v-deep {
    .van-overlay {
        z-index: 10000 !important;
    }
    .van-popup {
        z-index: 10001 !important;
    }
}
.h2 {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
}
.index-info {
    position: relative;
    .content {
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        .yz-list {
            padding: 16px;
            // .yz-ul {
            //   border-radius: 8px;
            //   padding: 4px 8px;
            //   background: rgba(247, 247, 252, 0.64);
            //   margin-top: 8px;
            //   li {
            //     margin: 6px 0;
            //     border: 1px solid #e7e7e7;
            //     padding: 3.5px;
            //     border-radius: 4px;
            //     display: flex;
            //     align-items: center;
            //     justify-content: space-between;
            //     background: #fff;
            //     .a-left {
            //       font-size: 14px;
            //       color: rgba(0, 0, 0, 0.9);
            //       padding-left: 9.5px;
            //       .gs {
            //         border-radius: 20px;
            //         border: 1.5px solid #2999df;
            //         padding: 0 8px;
            //         color: #2999df;
            //         font-size: 10px;
            //         flex-shrink: 0;
            //         height: 16px;
            //         margin-top: 2px;
            //         margin-left: 4px;
            //         display: flex;
            //         align-items: center;
            //       }
            //       .XiFenZhongLei {
            //         font-size: 10px;
            //         color: #999;
            //       }
            //     }
            //     .a-right {
            //       border-radius: 4px;
            //       padding: 8px 12px;
            //       background: rgba(0, 0, 0, 0.02);
            //       display: flex;
            //       align-items: center;
            //       justify-content: space-between;
            //       width: 50%;
            //       font-size: 12px;
            //       color: #555;
            //       img {
            //         width: 17px;
            //         height: 16px;
            //         flex-shrink: 0;
            //       }
            //     }
            //   }
            // }
        }
        .condition {
            background: #fff;
            border-radius: 8px 8px 0 0;
            padding: 16px 16px 90px;
            height: 100%;
            .period {
                ::v-deep {
                    .van-col {
                        div {
                            height: 32px;
                            border-radius: 6px;
                            border: 1px solid #e5e5e5;
                            margin-top: 8px;
                            font-size: 14px;
                            font-weight: normal;
                            color: #555;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .active {
                            background: rgba(40, 109, 247, 0.06);
                            border: 1px solid #286df7;
                            color: #286df7;
                        }
                    }
                }
            }
            .period-value {
                ::v-deep {
                    .van-cell {
                        margin-top: 8px;
                        padding: 0;
                    }

                    .van-field__control {
                        height: 32px;
                        border-radius: 6px;
                        padding: 6px 12px;
                        background: #f7f7fc;
                        &::placeholder {
                            text-align: center;
                        }
                    }
                }
            }
            .date-time {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 8px;
                p {
                    &:nth-child(1),
                    &:nth-child(3) {
                        height: 32px;
                        border-radius: 6px;
                        padding: 6px 12px;
                        background: #f7f7fc;
                        width: 100%;
                        font-size: 14px;
                        color: #999;
                        text-align: center;
                    }
                    &:nth-child(2) {
                        font-size: 14px;
                        color: #999;
                        padding: 0 10px;
                    }
                }
            }
        }
    }
    .bottom-pd {
        // position: absolute;
        position: fixed;
        bottom: 34px;
        left: 0px;
        width: 100%;
        padding: 0 16px;
        z-index: 99;
        .bottom-btn {
            border-radius: 20px;
            background: #0e0c0d;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            z-index: 9;

            .left {
                font-size: 16px;
                color: #fff;
                display: flex;
                align-items: center;
                padding: 8px 0 8px 23px;
                .num {
                    font-size: 14px;
                    width: 24px;
                    height: 24px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    background: #3b85fe;
                    margin-left: 8px;
                }
            }
            ::v-deep {
                .r-btn {
                    font-size: 16px;
                    color: #fff;
                    background: #286df7;
                    padding: 0px 16px;
                    border-radius: 0 20px 20px 0;
                    height: 40px;
                    border: none;
                }
            }
        }
        .setup-ing {
            height: 40px;
            border-radius: 20px;
            background: #0e0c0d;
            width: 100%;
            font-size: 14px;
            color: #fff;
        }
    }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
    .content {
        .yz-list {
            .h2 {
                color: #e4e9fe;
            }
        }
        .yz-ul {
            background: rgba(255, 255, 255, 0.15) !important;
            li {
                background: rgb(30, 31, 45) !important;
                border: 1px solid rgb(30, 31, 45) !important;
                .a-left,
                .a-right .zhi {
                    color: #e4e9fe !important;
                }
                .a-right {
                    p {
                        color: #aab9d1;
                    }
                }
            }
        }
        .condition {
            background: #191a24;
            .h2 {
                color: #e4e9fe;
            }
            .period {
                ::v-deep {
                    .van-col {
                        div {
                            border: 1px solid #2f3548;
                            background: #2f3548;
                            color: #e4e9fe !important;
                        }
                        .active {
                            background: rgba(59, 133, 254, 0.2);
                        }
                    }
                }
            }
            .date-time {
                p {
                    color: #6b7687 !important;
                    background: #191a24 !important;
                    &:first-child,
                    &:last-child {
                        border: 1px solid rgba(255, 255, 255, 0.1);
                    }
                }
            }
            .van-popup {
                background: #1e1f2d;
            }
        }
    }

    .period-value {
        .isShowCgzqText {
            font-size: 12px;
            color: #f00;
        }
        .van-cell {
            border: 1px solid #46484f !important;

            background: none !important;
            border-radius: 0.16rem;

            &::after {
                border: none;
            }

            ::v-deep {
                .van-field__control {
                    color: #e4e9fe !important;
                    background: none !important;
                }
            }
        }
    }

    .bottom-btn {
        background: #2e3548 !important;
    }
    .setup-ing {
        background: #2e3548 !important;
        border: none;
    }
}
</style>
